export default {
    "refrigerant-temperature": {
        "menu": "Diagnostics",
        "title": "Refrigerant temperature",
        "linkTitle": "Refrigerant temperature",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "hasOnOnlySwitch": true,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'variable-x': 'Cond_Sat_Ref_Temperature_Ckt1',
                        'layout-overrides': {
                            'barmode': "overlay",
                            title: "Cond_Sat_Ref_Temperature",
                            xaxis: {
                                title: "Cond_Sat_Ref_Temperature_Ckt1 (°C)"
                            },
                            yaxis: {
                                title: "Count"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                id: 1,
                                opacity: 0.5,
                                name: "Cond_Sat_Ref_Temperature_Ckt1"
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                id: 2,
                                opacity: 0.5,
                                name: "Cond_Sat_Ref_Temperature_Ckt1"
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                id: 3,
                                opacity: 0.5,
                                name: "Cond_Sat_Ref_Temperature_Ckt1"
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                id: 4,
                                opacity: 0.5,
                                name: "Cond_Sat_Ref_Temperature_Ckt1"
                            },
                        ],
                        'type': 'histogram',
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'variable-x': 'Cond_Sat_Ref_Temperature_Ckt2',
                        'layout-overrides': {
                            'barmode': "overlay",
                            title: "Cond_Sat_Ref_Temperature",
                            xaxis: {
                                title: "Cond_Sat_Ref_Temperature_Ckt2 (°C)"
                            },
                            yaxis: {
                                title: "Count"
                            },
                        },
                        'variables-list': [
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                id: 1,
                                opacity: 0.5,
                                name: "Cond_Sat_Ref_Temperature_Ckt2"
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                id: 2,
                                opacity: 0.5,
                                name: "Cond_Sat_Ref_Temperature_Ckt2"
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                id: 3,
                                opacity: 0.5,
                                name: "Cond_Sat_Ref_Temperature_Ckt2"
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                id: 4,
                                opacity: 0.5,
                                name: "Cond_Sat_Ref_Temperature_Ckt2"
                            },
                        ],
                        'type': 'histogram',
                    }
                },
                {
                    'id': 3,
                    'type': 'multi-chart',
                    'config': {
                        'variable-x': 'Evap_Sat_Ref_Temperature_Ckt1',
                        'layout-overrides': {
                            'barmode': "overlay",
                            title: "Evap_Sat_Ref_Temperature",
                            xaxis: {
                                title: "Evap_Sat_Ref_Temperature_Ckt1 (°C)"
                            },
                            yaxis: {
                                title: "Count"
                            },
                        },
                        'variables-list': [
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                id: 1,
                                opacity: 0.5,
                                name: "Evap_Sat_Ref_Temperature_Ckt1"
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                id: 2,
                                opacity: 0.5,
                                name: "Evap_Sat_Ref_Temperature_Ckt1"
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                id: 3,
                                opacity: 0.5,
                                name: "Evap_Sat_Ref_Temperature_Ckt1"
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                id: 4,
                                opacity: 0.5,
                                name: "Evap_Sat_Ref_Temperature_Ckt1"
                            },
                        ],
                        'type': 'histogram',
                    }
                },
                {
                    'id': 4,
                    'type': 'multi-chart',
                    'config': {
                        'variable-x': 'Evap_Sat_Ref_Temperature_Ckt2',
                        'layout-overrides': {
                            'barmode': "overlay",
                            title: "Evap_Sat_Ref_Temperature",
                            xaxis: {
                                title: "Evap_Sat_Ref_Temperature_Ckt2 (°C)"
                            },
                            yaxis: {
                                title: "Count"
                            },
                        },
                        'variables-list': [
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                id: 1,
                                opacity: 0.5,
                                name: "Evap_Sat_Ref_Temperature_Ckt2"
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                id: 2,
                                name: "Evap_Sat_Ref_Temperature_Ckt2"
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                id: 3,
                                opacity: 0.5,
                                name: "Evap_Sat_Ref_Temperature_Ckt2"
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                id: 4,
                                opacity: 0.5,
                                name: "Evap_Sat_Ref_Temperature_Ckt2"
                            },
                        ],
                        'type': 'histogram',
                    }
                }

            ]
    },
    "refrigerant-health": {
        "menu": "Diagnostics",
        "title": "Refrigerant health",
        "linkTitle": "Refrigerant health",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "hasOnOnlySwitch": true,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "Relation of Temperature and Pressure on Condensor",
                            xaxis: {
                                title: "Condensor Temperature (°C)"
                            },
                            yaxis: {
                                title: "Condensor Pressure (kPa)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Cond_Sat_Ref_Pressure_Ckt1",
                                variableX: "Cond_Sat_Ref_Temperature_Ckt1"
                            },
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Cond_Sat_Ref_Pressure_Ckt2",
                                variableX: "Cond_Sat_Ref_Temperature_Ckt2"
                            },

                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Cond_Sat_Ref_Pressure_Ckt1",
                                variableX: "Cond_Sat_Ref_Temperature_Ckt1"
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Cond_Sat_Ref_Pressure_Ckt2",
                                variableX: "Cond_Sat_Ref_Temperature_Ckt2"
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Cond_Sat_Ref_Pressure_Ckt1",
                                variableX: "Cond_Sat_Ref_Temperature_Ckt1"
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Cond_Sat_Ref_Pressure_Ckt2",
                                variableX: "Cond_Sat_Ref_Temperature_Ckt2"
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Cond_Sat_Ref_Pressure_Ckt1",
                                variableX: "Cond_Sat_Ref_Temperature_Ckt1"
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Cond_Sat_Ref_Pressure_Ckt2",
                                variableX: "Cond_Sat_Ref_Temperature_Ckt2"
                            }

                        ],
                        'type': 'scatter',
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "Relaions of Temperature and Pressure on Evaporator",
                            xaxis: {
                                title: "Evaporator  Temperature (°C)"
                            },
                            yaxis: {
                                title: "Evaporator  Pressure (kPa)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Evap_Ref_Pressure_Ckt1",
                                variableX: "Evap_Sat_Ref_Temperature_Ckt1"
                            },
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Evap_Ref_Pressure_Ckt2",
                                variableX: "Evap_Sat_Ref_Temperature_Ckt2"
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Evap_Ref_Pressure_Ckt1",
                                variableX: "Evap_Sat_Ref_Temperature_Ckt1"
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Evap_Ref_Pressure_Ckt2",
                                variableX: "Evap_Sat_Ref_Temperature_Ckt2"
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Evap_Ref_Pressure_Ckt1",
                                variableX: "Evap_Sat_Ref_Temperature_Ckt1"
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Evap_Ref_Pressure_Ckt2",
                                variableX: "Evap_Sat_Ref_Temperature_Ckt2"
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Evap_Ref_Pressure_Ckt1",
                                variableX: "Evap_Sat_Ref_Temperature_Ckt1"
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                mode: 'markers',
                                name: "Evap_Ref_Pressure_Ckt2",
                                variableX: "Evap_Sat_Ref_Temperature_Ckt2"
                            },
                        ],
                        'type': 'scatter',
                    }
                }


            ]
    },
    "motor-health": {
        "menu": "Diagnostics",
        "title": "Motor health",
        "linkTitle": "Motor health",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "hasOnOnlySwitch": true,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            barmode: "overlay",
                            title: "ACPC-1 Winding Temperature",
                            xaxis: {
                                title: "Winding Temperature (°C)",
                                range: [0, 50]
                            },
                            yaxis: {
                                title: "Count"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                id: 1,
                                opacity: 0.5,
                                name: "Winding_Temp_#1_Motor_1A",
                                variableX: "Winding_Temp_#1_Motor_1A",
                                xbins: {
                                    size: 2
                                }
                            },
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                id: 2,
                                opacity: 0.5,
                                name: "Winding_Temp_#2_Motor_1A",
                                variableX: "Winding_Temp_#2_Motor_1A",
                                xbins: {
                                    size: 2
                                }
                            },
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                id: 3,
                                opacity: 0.5,
                                name: "Winding_Temp_#1_Motor_2A",
                                variableX: "Winding_Temp_#1_Motor_2A",
                                xbins: {
                                    size: 2
                                }
                            },
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                id: 4,
                                opacity: 0.5,
                                name: "Winding_Temp_#2_Motor_2A",
                                variableX: "Winding_Temp_#2_Motor_2A",
                                xbins: {
                                    size: 2
                                }
                            }
                        ],
                        'type': 'histogram',
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            barmode: "overlay",
                            title: "ACPC-2 Winding Temperature",
                            xaxis: {
                                title: "Winding Temperature (°C)",
                                range: [0, 52]
                            },
                            yaxis: {
                                title: "Count",
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                id: 1,
                                opacity: 0.5,
                                name: "Winding_Temp_#1_Motor_1A",
                                variableX: "Winding_Temp_#1_Motor_1A",
                                xbins: {
                                    size: 2
                                }
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                id: 2,
                                opacity: 0.5,
                                name: "Winding_Temp_#2_Motor_1A",
                                variableX: "Winding_Temp_#2_Motor_1A",
                                xbins: {
                                    size: 2
                                }
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                id: 3,
                                opacity: 0.5,
                                name: "Winding_Temp_#1_Motor_2A",
                                variableX: "Winding_Temp_#1_Motor_2A",
                                xbins: {
                                    size: 2
                                }
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                id: 4,
                                opacity: 0.5,
                                name: "Winding_Temp_#2_Motor_2A",
                                variableX: "Winding_Temp_#2_Motor_2A",
                                xbins: {
                                    size: 2
                                }
                            }
                        ],
                        'type': 'histogram',
                    }
                },
                {
                    'id': 3,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            barmode: "overlay",
                            title: "ACPC-3 Winding Temperature",
                            xaxis: {
                                title: "Winding Temperature (°C)",
                                range: [0, 50]
                            },
                            yaxis: {
                                title: "Count",
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                id: 1,
                                opacity: 0.5,
                                name: "Winding_Temp_#1_Motor_1A",
                                variableX: "Winding_Temp_#1_Motor_1A",
                                xbins: {
                                    size: 2
                                }
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                id: 2,
                                opacity: 0.5,
                                name: "Winding_Temp_#2_Motor_1A",
                                variableX: "Winding_Temp_#2_Motor_1A",
                                xbins: {
                                    size: 2
                                }
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                id: 3,
                                opacity: 0.5,
                                name: "Winding_Temp_#1_Motor_2A",
                                variableX: "Winding_Temp_#1_Motor_2A",
                                xbins: {
                                    size: 2
                                }
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                id: 4,
                                opacity: 0.5,
                                name: "Winding_Temp_#2_Motor_2A",
                                variableX: "Winding_Temp_#2_Motor_2A",
                                xbins: {
                                    size: 2
                                }
                            }
                        ],
                        'type': 'histogram',
                    }
                },
                {
                    'id': 4,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            barmode: "overlay",
                            title: "ACPC-4 Winding Temperature",
                            xaxis: {
                                title: "Winding Temperature (°C)",
                                range: [0, 55]
                            },
                            yaxis: {
                                title: "Count",
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                id: 1,
                                opacity: 0.5,
                                name: "Winding_Temp_#1_Motor_1A",
                                variableX: "Winding_Temp_#1_Motor_1A",
                                xbins: {
                                    size: 2
                                }
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                id: 2,
                                opacity: 0.5,
                                name: "Winding_Temp_#2_Motor_1A",
                                variableX: "Winding_Temp_#2_Motor_1A",
                                xbins: {
                                    size: 2
                                }
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                id: 3,
                                opacity: 0.5,
                                name: "Winding_Temp_#1_Motor_2A",
                                variableX: "Winding_Temp_#1_Motor_2A",
                                xbins: {
                                    size: 2
                                }
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                id: 4,
                                opacity: 0.5,
                                name: "Winding_Temp_#2_Motor_2A",
                                variableX: "Winding_Temp_#2_Motor_2A",
                                xbins: {
                                    size: 2
                                }
                            }
                        ],
                        'type': 'histogram',
                    }
                },


            ]
    },
    "chws": {
        "menu": "Diagnostics",
        "title": "CHW Supply Temperature",
        "linkTitle": "CHW Supply Temperature",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "hasOnOnlySwitch": true,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "Relation of Outdoor Temperature and CHWS Temperature",
                            xaxis: {
                                title: "Outdoor Temperature (°C)"
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "CHWS_Temp",
                                variableX: "Outdoor_Air_Temperature"
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "CHWS_Temp",
                                variableX: "Outdoor_Air_Temperature"
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "CHWS_Temp",
                                variableX: "Outdoor_Air_Temperature"
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "CHWS_Temp",
                                variableX: "Outdoor_Air_Temperature"
                            },

                        ],
                        'type': 'scattergl',
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "CHWS Temperature",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                name: "CHWS_Temp",
                            },

                        ],
                    }
                },
                {
                    'id': 3,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "Relation of Outdoor Temperature and Header Supply Temperature",
                            xaxis: {
                                title: "Outdoor Temperature (°C)"
                            },
                            yaxis: {
                                title: "Header Main Supply Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "Outdoor_Temperature",
                                useAsXVariable: true
                            },
                            {
                                equipment_name: "Chiller Header",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "Main_Supply_Temp",
                                useXAsHover: true
                            }

                        ],
                        'type': 'scattergl',
                    }
                },
                {
                    'id': 4,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "Chiller Header Supply Temperature",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Header Main Supply Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Chiller Header",
                                facility_name: "SHT",
                                name: "Main_Supply_Temp",
                            }

                        ],
                    }
                },
            ]
    },
    "cop": {
        "menu": "Diagnostics",
        "title": "COP",
        "linkTitle": "COP",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'cop',
                    'config': {
                        'layout-overrides': {
                            title: "Plant COP",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Plant COP"
                            }
                        },
                        'variable-x': 'timestamp',
                        'variable-y': 'COP',
                        'type': 'scatter',
                    }
                },
                {
                    'id': 2,
                    'type': 'cop',
                    'config': {
                        'layout-overrides': {
                            title: "Relation of Cooling Load and Plant COP",
                            xaxis: {
                                title: "Cooling Load (kW)"
                            },
                            yaxis: {
                                title: "Plant COP"
                            }
                        },
                        'variable-x': 'Cooling_Load',
                        'variable-y': 'COP',
                        'mode': 'markers',
                        'type': 'scatter',
                    }
                },
                {
                    'id': 3,
                    'type': 'cop',
                    'config': {
                        'layout-overrides': {
                            title: "Relation of Outdoor Temperature and Plant COP",
                            xaxis: {
                                title: "Outdoor Temperature (°C)"
                            },
                            yaxis: {
                                title: "Plant COP"
                            }
                        },
                        'variable-x': 'Outdoor_Temperature',
                        'variable-y': 'COP',
                        'mode': 'markers',
                        'type': 'scatter',
                        'extra-vars': [
                            {
                                'equipment_name': 'Weather',
                                'sensor_names': ['Outdoor_Temperature']
                            }
                        ]
                    }
                },
                {
                    'id': 4,
                    'type': 'cop',
                    'config': {
                        'layout-overrides': {
                            title: "Cooling Load",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Cooling Load (kW)"
                            }
                        },
                        'variable-x': 'timestamp',
                        'variable-y': 'Cooling_Load',
                        'type': 'scatter',
                    }
                },
                {
                    'id': 5,
                    'type': 'cop',
                    'config': {
                        'layout-overrides': {
                            title: "Power",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Power (kWh)"
                            }
                        },
                        'variable-x': 'timestamp',
                        'variable-y': 'power',
                        'type': 'scatter',
                    }
                },

            ]
    },
    "chwp": {
        "menu": "Diagnostics",
        "title": "Pumps",
        "linkTitle": "Pumps",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "Relation of Pump Power and VSD Speed Feedback",
                            xaxis: {
                                title: "KW",
                                range: [1, 16]
                            },
                            yaxis: {
                                title: "VSD Speed Feedback",
                                range: [40, 50]
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "CHWP-001",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "VSD_Speed_Feedback",
                                variableX: "KW"
                            },
                            {
                                equipment_name: "CHWP-002",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "VSD_Speed_Feedback",
                                variableX: "KW"
                            },
                            {
                                equipment_name: "CHWP-003",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "VSD_Speed_Feedback",
                                variableX: "KW"
                            },
                            {
                                equipment_name: "CHWP-004",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "VSD_Speed_Feedback",
                                variableX: "KW"
                            },
                            {
                                equipment_name: "CHWP-005",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "VSD_Speed_Feedback",
                                variableX: "KW"
                            },

                        ],
                        'type': 'scattergl',
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            height: 700,
                            barmode: "overlay",
                            title: "Pump Power",
                            xaxis: {
                                title: "KW",
                                range: [1, 16]
                            },
                            yaxis: {
                                title: "Count",
                                range: [0, 400]
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "CHWP-001",
                                facility_name: "SHT",
                                id: 1,
                                opacity: 0.5,
                                name: "KW",
                                variableX: "KW"
                            },
                            {
                                equipment_name: "CHWP-002",
                                facility_name: "SHT",
                                id: 1,
                                opacity: 0.5,
                                name: "KW",
                                variableX: "KW"
                            },
                            {
                                equipment_name: "CHWP-003",
                                facility_name: "SHT",
                                id: 1,
                                opacity: 0.5,
                                name: "KW",
                                variableX: "KW"
                            },
                            {
                                equipment_name: "CHWP-004",
                                facility_name: "SHT",
                                id: 1,
                                opacity: 0.5,
                                name: "KW",
                                variableX: "KW"
                            },
                            {
                                equipment_name: "CHWP-005",
                                facility_name: "SHT",
                                id: 1,
                                opacity: 0.5,
                                name: "KW",
                                variableX: "KW"
                            },


                        ],
                        'type': 'histogram',
                    }
                },
            ]
    },
    "system-performance": {
        "menu": "Diagnostics",
        "title": "System Performance",
        "linkTitle": "System Performance",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "Outdoor Temperature and Chiller Header Temperature",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "SHT",
                                name: "Outdoor_Temperature",
                            },
                            {
                                equipment_name: "Chiller Header",
                                facility_name: "SHT",
                                name: "Main_Supply_Temp",
                            },
                            {
                                equipment_name: "Chiller Header",
                                facility_name: "SHT",
                                name: "Main_Return_Temp",
                            },
                            {
                                equipment_name: "Chiller Header",
                                facility_name: "SHT",
                                name: "CHW_Temp_Diff",
                            }
                        ],
                    }
                },
                {
                    'id': 6,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Flow Rate",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Flow Rate (L/s)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Chiller Header",
                                facility_name: "SHT",
                                name: "Flow_Rate",
                            }

                        ],
                    }
                }

            ]
    },
    "chiller-performance": {
        "menu": "Diagnostics",
        "title": "Chiller Performance",
        "linkTitle": "Chiller Performance",
        "viewType": "plot-list",
        "hasEquipmentSelector":true,
        "equipmentTypeFilter":"chiller",
        "hasOnOnlySwitch": true,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "Outdoor Temperature and CHWS Temperature",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                facility_name: "SHT",
                                name: "Outdoor_Air_Temperature",
                            },
                            {
                                facility_name: "SHT",
                                name: "CHWS_Temp",
                            },
                            {
                                facility_name: "SHT",
                                name: "CHW_Temp_Diff",
                            }

                        ],
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            showlegend:true,
                            title: "Flow Rate",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Flow Rate (L/s)"
                            }
                        },
                        'variables-list': [
                            {
                                facility_name: "SHT",
                                name: "Flow_Rate",
                            },


                        ],
                    }
                },
                {
                    'id': 3,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            showlegend:true,
                            title: "COP",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "COP"
                            }
                        },
                        'variables-list': [
                            {
                                facility_name: "SHT",
                                name: "efficiency",
                            },


                        ],
                    }
                }

            ]
    },
    "cooling-performance": {
        "menu": "Diagnostics",
        "title": "Cooling Performance",
        "linkTitle": "Cooling Performance",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "plotList":
            [
                {
                    'id': 6,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Cooling Load ",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis:{
                                title:"Cooling Load (kWh)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },


                        ],
                    }
                },
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Power (Chiller only) ",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis:{
                                title:"Power Consumption (kWh)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },


                        ],
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Power Consumption",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis:{
                                title:"Power Consumption (kWh)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "CHWP-001",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "KW",
                            },
                            {
                                equipment_name: "CHWP-002",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                name: "KW",
                                mode: 'none',
                            },
                            {
                                equipment_name: "CHWP-003",
                                facility_name: "SHT",
                                mode: 'none',
                                stackgroup: 'one',
                                name: "KW",
                            },
                            {
                                equipment_name: "CHWP-004",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "KW",
                            },
                            {
                                equipment_name: "CHWP-005",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "KW",
                            },


                        ],
                    }
                },
                {
                    'id': 3,
                    'type': 'cop',
                    'config': {
                        'layout-overrides': {
                            "title":"Plant COP",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                        },
                        'variable-x': 'timestamp',
                        'variable-y': 'COP',
                        'type': 'scatter',
                    }
                },

            ]
    },
    "working-hours": {
        "menu": "Diagnostics",
        "title": "Working Hours",
        "linkTitle": "Working Hours",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Cooling Load ",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis:{
                                title:"Cooling Load (kW)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                type: 'scatter',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },


                        ],
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Chillers On",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "on",
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "on",
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "on",
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "on",
                            },


                        ],
                    }
                },
                {
                    'id': 3,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Pumps On",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "CHWP-001",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "on",
                            },
                            {
                                equipment_name: "CHWP-002",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "on",
                            },
                            {
                                equipment_name: "CHWP-003",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "on",
                            },
                            {
                                equipment_name: "CHWP-004",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "on",
                            },
                            {
                                equipment_name: "CHWP-005",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "on",
                            },


                        ],
                    }
                },
                {
                    'id': 5,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Chilled Water Delta Temperature",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Temperature Diff (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Chiller Header",
                                facility_name: "SHT",
                                name: "CHW_Temp_Diff",
                            }
                        ],
                    }
                },
                {
                    'id': 6,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Flow Rate",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Flow Rate (L/s)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Chiller Header",
                                facility_name: "SHT",
                                name: "Flow_Rate",
                            }

                        ],
                    }
                }



            ]
    },
    "ahu": {
        "menu": "Diagnostics",
        "title": "AHU",
        "linkTitle": "AHU",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "hasOnOnlySwitch": true,
        "plotList":
            [
                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"All AHUs Return Air Temperatures",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "AHU-036",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-036 OS34.points.Sensor.Return Air GTemp",
                            },
                            {
                                equipment_name: "AHU-037",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-037 OS24.points.Sensor.RETURN AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-038",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-038 OS25.points.Sensor.RETURN AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-039",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-039 OS30.points.Sensor.RETURN AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-040",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-040 OS31.points.Sensor.RETURN AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-041",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-041 OS32.points.Sensor.RETURN AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-042",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-042 OS33.points.Sensor.RETURN AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-043",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-043 OS35.points.Sensor.RETURN AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-044",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-044 OS36.points.Sensor.RETURN AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-045",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-045 OS37.points.Sensor.RETURN AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-046",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-046 OS38.points.Sensor.RETURN AIR TEMP",
                            },



                        ],
                    }
                },{
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"All AHUs Supply Air Temperature",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "AHU-036",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-036 OS34.points.Sensor.SUPPLY AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-037",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-037 OS24.points.Sensor.SUPPLY AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-038",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-038 OS25.points.Sensor.SUPPLY AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-039",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-039 OS30.points.Sensor.SUPPLY AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-040",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-040 OS31.points.Sensor.SUPPLY AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-041",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-041 OS32.points.Sensor.SUPPLY AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-042",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-042 OS33.points.Sensor.SUPPLY AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-043",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-043 OS35.points.Sensor.SUPPLY AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-044",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-044 OS36.points.Sensor.SUPPLY AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-045",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-045 OS37.points.Sensor.SUPPLY AIR TEMP",
                            },
                            {
                                equipment_name: "AHU-046",
                                facility_name: "SHT",
                                name: "Drivers.TrendIpNetwork.SHT-ECS-AHU-046 OS38.points.Sensor.SUPPLY AIR TEMP",
                            },



                        ],
                    }
                },


            ]
    },
    "time-series-charts": {
        "menu": "Diagnostics",
        "title": "Time Series Charts",
        "linkTitle": "Time Series Charts",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "plotList":
            [
                {
                    'id': 3,
                    'type': 'cop',
                    'config': {
                        'layout-overrides': {
                            "title":"COP",
                            legend: {
                                orientation: 'h',
                                x: 0,
                                y: -0.2
                            },
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis2: {
                                title: 'Outdoor Temperature (°C)',
                                overlaying: 'y',
                                side: 'right'
                            }
                        },
                        'variable-x': 'timestamp',
                        'variable-y': 'COP',
                        'type': 'scatter',
                        'ony2':'Outdoor_Temperature',
                        'extra-vars': [
                            {
                                'equipment_name': 'Weather',
                                'sensor_names': ['Outdoor_Temperature']
                            }
                        ]
                    }
                },
                {
                    'id': 123,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            xaxis: {
                                title: "Date (every 15 minutes)"
                            },
                            legend: {
                                orientation: 'h',
                                x: 0,
                                y: -0.2
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            },
                            yaxis2: {
                                title: 'Outdoor Temperature (°C)',
                                overlaying: 'y',
                                side: 'right'
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "SHT",
                                yaxis: 'y2',
                                name: "Outdoor_Temperature",
                            },
                            {
                                equipment_name: "Chiller Header",
                                facility_name: "SHT",
                                name: "Main_Supply_Temp",
                            },
                            {
                                equipment_name: "Chiller Header",
                                facility_name: "SHT",
                                name: "Main_Return_Temp",
                            }
                        ],
                    }
                },
                {
                    'id': 6,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Cooling Load ",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            legend: {
                                orientation: 'h',
                                x: 0,
                                y: -0.2
                            },
                            yaxis: {title: 'Cooling Load (kW)'},
                            yaxis2: {
                                title: 'Outdoor Temperature (°C)',
                                overlaying: 'y',
                                side: 'right'
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "SHT",
                                yaxis: 'y2',
                                name: "Outdoor_Temperature",
                            },
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                type: 'scatter',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Cooling_Load",
                            },


                        ],
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Power Consumption",
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            legend: {
                                orientation: 'h',
                                x: 0,
                                y: -0.2
                            },
                            yaxis: {title: 'Power Consumption (kWh)'},
                            yaxis2: {
                                title: 'Outdoor Temperature (°C)',
                                overlaying: 'y',
                                side: 'right'
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "SHT",
                                yaxis: 'y2',
                                name: "Outdoor_Temperature",
                            },
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "CHWP-001",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "KW",
                            },
                            {
                                equipment_name: "CHWP-002",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                name: "KW",
                                mode: 'none',
                            },
                            {
                                equipment_name: "CHWP-003",
                                facility_name: "SHT",
                                mode: 'none',
                                stackgroup: 'one',
                                name: "KW",
                            },
                            {
                                equipment_name: "CHWP-004",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "KW",
                            },
                            {
                                equipment_name: "CHWP-005",
                                facility_name: "SHT",
                                stackgroup: 'one',
                                mode: 'none',
                                name: "KW",
                            },


                        ],
                    }
                },
                {
                    'id': 12,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"CHWST & CHWRT",
                            legend: {
                                orientation: 'h',
                                x: 0,
                                y: -0.2
                            },
                            xaxis: {
                                title: "Time (every 15 minutes)"
                            },
                            yaxis: {title: 'Temperature (°C)'},
                            yaxis2: {
                                title: 'Outdoor Temperature (°C)',
                                overlaying: 'y',
                                side: 'right'
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "SHT",
                                yaxis: 'y2',
                                name: "Outdoor_Temperature",
                            },
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                name: "CHWS_Temp",
                            },{
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                name: "CHWR_Temp",
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                name: "CHWR_Temp",
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                name: "CHWR_Temp",
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                name: "CHWR_Temp",
                            },

                        ],
                    }
                },
            ]
    },
    "outdoor-temperature-charts": {
        "menu": "Diagnostics",
        "title": "Outdoor Temperature Charts",
        "linkTitle": "Outdoor Temperature Charts",
        "viewType": "plot-list",
        "hasEquipmentSelector": false,
        "plotList":
            [

                {
                    'id': 1,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "CHWS Temperature",
                            xaxis: {
                                title: "Outdoor Temperature (°C)"
                            },
                            yaxis: {
                                title: "Temperature (°C)"
                            }
                        },
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "Outdoor_Temperature",
                                useAsXVariable: true
                            },
                            {
                                equipment_name: "Chiller Header",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "Main_Supply_Temp",
                            },
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "CHWS_Temp",
                            },

                        ],
                        'type': 'scattergl',
                    }
                },
                {
                    'id': 3,
                    'type': 'cop',
                    'config': {
                        'layout-overrides': {
                            title: "Plant COP",
                            xaxis: {
                                title: "Outdoor Temperature (°C)"
                            },
                            yaxis: {
                                title: "Plant COP"
                            }
                        },
                        'variable-x': 'Outdoor_Temperature',
                        'variable-y': 'COP',
                        'mode': 'markers',
                        'type': 'scatter',
                        'extra-vars': [
                            {
                                'equipment_name': 'Weather',
                                'sensor_names': ['Outdoor_Temperature']
                            }
                        ]
                    }
                },
                {
                    'id': 14,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title: "COP",
                            xaxis: {
                                title: "Outdoor Temperature (°C)"
                            },
                            yaxis: {
                                title: "COP"
                            }
                        },
                        'variables-list': [

                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "efficiency",
                                variableX: "Outdoor_Air_Temperature"
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "efficiency",
                                variableX: "Outdoor_Air_Temperature"
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "efficiency",
                                variableX: "Outdoor_Air_Temperature"
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "efficiency",
                                variableX: "Outdoor_Air_Temperature"
                            },

                        ],
                        'type': 'scattergl',
                    }
                },
                {
                    'id': 2,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Power Consumption",
                            xaxis: {
                                title: "Outdoor Temperature (°C)"
                            },
                            yaxis: {
                                title: "Power Consumption (kWh)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "Weather",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "Outdoor_Temperature",
                                useAsXVariable: true
                            },
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "Comp_Power",
                            },
                            {
                                equipment_name: "CHWP-001",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "KW",
                            },
                            {
                                equipment_name: "CHWP-002",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "KW",
                            },
                            {
                                equipment_name: "CHWP-003",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "KW",
                            },
                            {
                                equipment_name: "CHWP-004",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "KW",
                            },
                            {
                                equipment_name: "CHWP-005",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "KW",
                            },


                        ],
                    }
                },
                {
                    'id': 6,
                    'type': 'multi-chart',
                    'config': {
                        'layout-overrides': {
                            title:"Cooling Load ",
                            xaxis: {
                                title: "Outdoor Temperature (°C)"
                            },
                            yaxis: {
                                title: "Cooling Load (kW)"
                            }
                        },
                        type: 'scatter',
                        'variables-list': [
                            {
                                equipment_name: "ACPC-1",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "Cooling_Load",
                                variableX: "Outdoor_Air_Temperature"
                            },
                            {
                                equipment_name: "ACPC-2",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "Cooling_Load",
                                variableX: "Outdoor_Air_Temperature"
                            },
                            {
                                equipment_name: "ACPC-3",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "Cooling_Load",
                                variableX: "Outdoor_Air_Temperature"
                            },
                            {
                                equipment_name: "ACPC-4",
                                facility_name: "SHT",
                                mode: "markers",
                                name: "Cooling_Load",
                                variableX: "Outdoor_Air_Temperature"
                            },


                        ],
                    }
                },


            ]
    },
};